<template>
    <div class="container-fluid">
        <div class="row">
            <amf-input label="Group Name" v-model="groupName" :columns="6" :aggressive="true"></amf-input>
            <amf-input label="Group Headquarter's Zip Code" v-model="groupZip" :columns="6" :aggressive="true"></amf-input>
        </div>
        <div class="row">
            <amf-datepicker label="Coverage Effective Date" v-model="effectiveDate" :columns="6" :aggressive="true" :min="today"></amf-datepicker>
        </div>
        <div class="row centered">
            <div class="col-6">
                <amf-button class="btn-secondary" :onClick="download" :disabled="busy">Download Blank Census</amf-button>
            </div>
            <div class="col-6">
                <label :class="['btn', uploadEnabled ? 'btn-success' : 'disabled', 'btn-file']">
                    Upload Census <input type="file" ref="uploader" style="display: none;" :disabled="!uploadEnabled" @change="censusUpload" />
                </label>
            </div>
        </div>
        <div v-if="infoMessage" class="row">
            <div class="col-12 mt-3" style="text-align: center;">
                <p>{{infoMessage}}</p>
                <div v-if="busy" class="fa-2x">
                    <i class="fa fa-spinner fa-spin"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AmfDatepicker from '../framework/primitives/AmfDatepicker.vue';
import { statesUs } from '../framework/utils/states-us';

export default {
  components: { AmfDatepicker },
    data() {
        return {
            groupName: null,
            groupZip: null,
            effectiveDate: null,
            states: statesUs,
            title: 'ICHRA Affordability Calculator',
            amfOptions: { layout: "twelve-column" },
        }
    },
    computed: {
        buttons() {
            return "Close";
        },
        uploadEnabled() {
            return this.groupName && this.groupZip && this.effectiveDate && !this.busy;
        },
        infoMessage() {
            if (this.busy && this.success == false) {
                return "Your ICHRA affordability results are being calculated. This may take several minutes.";
            }
            else if (!this.busy && this.success == true) {
                return "Your census has been processed. Please search your Downloads folder for your ICHRA affordability results.";
            }
            return "";
        },
        today() {
            return moment().format('YYYY-MM-DD');
        }
    },
    methods: {
        async download() {
            this.busy = true;
            await romeApi.download(`affordability/download-census`);
            this.busy = false;
        },
        async censusUpload() {
            this.busy = true;
            this.success = false;

            let selectedFile = this.$refs.uploader.files[0];
            if (!selectedFile) return;

            let formData = new FormData();
            formData.append('file', selectedFile);

            let selectedDate = new moment(this.effectiveDate).format("YYYY-MM-DD");

            let response = await romeApi.upload(`affordability/validate-census/?groupName=${this.groupName}&groupZip=${this.groupZip}&effectiveDate=${selectedDate}`, formData);
            if (response && response.failure && response.messages && response.messages.length > 0) {
                try {
                    await modalService.multiLineInfo(response.messages, undefined, 'Affordability Census Errors', true, { width:"850" });
                    this.success = null;
                } 
                catch (error) {}
            } else if (response && response.success) {
                await romeApi.generate(`affordability/upload-census/?groupName=${this.groupName}&groupZip=${this.groupZip}&effectiveDate=${selectedDate}`, `${this.groupName}_ICHRA Affordability Census Quote.xlsx`, response.value);
                this.success = true;
            }

            this.$refs.uploader.value = null;
            this.busy = false;
        }
    }
}
</script>

<style scoped>
.centered {
    margin-top: 1em;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/shared/AffordabilityCalculator.vue